<template>
  <div class="register">
    <img src="../../assets/imgs/loginBg.jpg" width="100%" :style="{ height: height + 'px' }" >
    <div class="main-form">
      <div class="main-title">用户注册</div>
      <a-form :form="form">
        <a-form-item  :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="用户名称">
            <a-input v-decorator="['nickname',{ rules: [{ required: true, message: '请输入用户名称' }] },]"
            placeholder="请输入用户名称"/>
        </a-form-item>
        <a-form-item  :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="账号">
            <a-input v-decorator="['username',{ rules: [{ required: true, message: '请输入账号' }] },]"
            placeholder="请输入账号"/>
        </a-form-item>   
        <a-form-item  :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="密码">
            <a-input type="password" v-decorator="['password',{ rules: [{ required: true, message: '请输入密码' }] },]"
            placeholder="请输入密码"/>
        </a-form-item> 
        <a-form-item  :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="确认密码">
            <a-input type="password" v-decorator="['passwordAg',{ rules: [{ required: true, message: '请确认密码' }] },]"
            placeholder="请确认密码"/>
        </a-form-item> 
        <!-- <a-form-item  :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="图形验证">
            <a-input type="password" v-decorator="['passwordAg',{ rules: [{ required: true, message: '请输入验证码' }] },]"
            placeholder="图形验证"/>
        </a-form-item>  -->
        <a-form-item  :label-col="formTailLayout.labelCol" :wrapper-col="formTailLayout.wrapperCol">
             <a-checkbox :checked="checkNick" @change="handleChange">
                <span @click="getUser">用户协议</span>
            </a-checkbox>
        </a-form-item> 
        <a-form-item :label-col="formTailLayout.labelCol" :wrapper-col="formTailLayout.wrapperCol">
            <a-button type="primary" @click="check"  :loading="loading"  style="width:100%;">
                确定
            </a-button>
        </a-form-item>
       </a-form>
    </div>
     <a-modal v-model="visible" title="用户协议" width="70%" cancelText="取消" okText="确定"  @ok="handleOk">
         <div v-html="content"></div>
    </a-modal>
  </div>
</template>

<script>
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 },
};
const formTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8, offset: 4 },
};
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      visible:false,
      content:null,
      height: null,
      checkNick: false,
      loading:false,
      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this, { name: 'dynamic_rule' }),
    };
  },
  created(){
      this.$https.get(`/portal/index/getContentById/13`).then(res=>{
          this.content = res[0].content
      })
  },
  mounted() {
    this.height = document.body.clientHeight - 85;
    // this.$https.get('/code').then(res=>{})
  },
  methods:{
    ...mapActions('home',['setAcount']),
    check() {
       if(!this.checkNick){
          this.$message.error('请勾选用户协议');
          return false;
      }
      this.form.validateFields((err,value) => {
        if (!err) {
          if(value.password != value.passwordAg){
             this.$message.error('两次密码不一致');
             return false;
          }
          this.loading = true;
          this.$https.post('/auth/register',value).then(res=>{
              this.loading = false;
              if(res.code == 200){
                 this.$message.success('注册成功')
                 let params = {
                     username:value.username,
                     password:value.password
                 }
                 this.$message.loading({ content: '正在登陆' },1);
                 this.$https.post('/portal/login',params).then(res=>{
                    this.loading = false;
                    if(res.code == 200){
                      this.$message.success({ content: '登录成功'},1);
                      sessionStorage.setItem('token',res.data.access_token);
                      sessionStorage.setItem('acount',params.username);
                      this.setAcount(value.username)
                      this.$store.dispatch('home/updateToken',res.data.access_token);
                      this.$router.push('/index');
                    }else{
                      this.$message.error(res.msg)
                    }
                 })
              }else{
                this.$message.error(res.msg);
              }
          })
        }
      });
    },
    handleChange(e) {
      this.checkNick = e.target.checked;
      this.$nextTick(() => {
        this.form.validateFields(['nickname'], { force: true });
      });
    },
    getUser(){
      this.visible = true;
    },
    handleOk(){
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.register {
  width: 100%;
  .main-form{
      width: 500px;
      position: absolute;
      right:150px;
      top:200px;
      .main-title{
          text-align: center;
          line-height: 80px;
          font-size: 16px;
          font-weight: bold;
          color:#999999;
      }
  }
}
</style>